

/******************************************************************/
/* Loop cart integration
/******************************************************************/

const headingWrapper = document.querySelector('div.addToCart__header');
const headingSingle = document.querySelector('div.heading_single');
const headingSub = document.querySelector('div.heading_sub');
const atc__oneTime= document.querySelector('.addToCart__oneTime');
const atc__subscription= document.querySelector('.addToCart__subscription');
const abo__btn = document.querySelector('.submit_sub');
const single__btn = document.querySelector('.submit_single');
const overflow_products = document.querySelector('.overflow_products');

// document.addEventListener("DOMContentLoaded", function(event) {
    const selectField = document.querySelector('.addToCart__select select');
    let selectedSellingplanId = parseInt(selectField.value);

    // call sellingplan function if select has changed
    selectField.addEventListener('change', function() {
        selectedSellingplanId = parseInt(this.value);
    });

    // single switch
    headingSingle.addEventListener("click", function() {
        switchToSingle();
    });

    // submit single
    document.querySelector('.submit_single').addEventListener("click", function() {
        addSellingPlanProducts(0, CartJS.cart.items.length, CartJS.cart.items);
        _this = this;
        _this.style.pointerEvents = "none";

        $(document).on('cart.requestComplete', function(event, cart) {
            document.querySelector(".to-checkout-button").click(); 
        });
    });

    // sub switch
    headingSub.addEventListener("click", function() {
        switchToSub();
    });

    // submit sub
    document.querySelector('.submit_sub').addEventListener("click", function() {
        addSellingPlanProducts(selectedSellingplanId, CartJS.cart.items.length, CartJS.cart.items);
        _this = this;
        _this.style.pointerEvents = "none";
        $(document).on('cart.requestComplete', async function(event, cart) {
            await fetch("/discount/HealthyHabit40");
            document.querySelector(".to-checkout-button").click(); 
        });
      
        
    });
// });
  
const addSellingPlanProducts = (sellingPlanId, CartItemsLength, CartItems) => {
    CartJS.clear();

    for (let i = 0; i < CartItemsLength; i++) {
        const variantId = CartItems[i].id;
        const quantity = CartItems[i].quantity;

        if (sellingPlanId != 0) {
            CartJS.addItem(variantId, quantity, {
                "selling_plan": sellingPlanId
            });
        }
        else {
            CartJS.addItem(variantId, quantity);
        }
    }
}

const switchToSingle = () => {
    headingSingle.style.color = "#000";
    headingSub.style.color = "#5c5c5c";
    headingWrapper.classList.remove("addToCart__header--subOpen");
    atc__subscription.style.display = "none";
    atc__oneTime.style.display = "block";
    abo__btn.style.display = "none";
    single__btn.style.display = "block";
    /*if(window.matchMedia("(max-width: 700px)").matches){
        overflow_products.style.maxHeight = "64vh !important";
    }*/
}

const switchToSub = () => {
    headingSingle.style.color = "#5c5c5c";
    headingSub.style.color = "#000";
    headingWrapper.classList.add("addToCart__header--subOpen");
    atc__subscription.style.display = "block";
    atc__oneTime.style.display = "none";
    abo__btn.style.display = "block";
    single__btn.style.display = "none";
    /*if(window.matchMedia("(max-width: 700px)").matches){
        overflow_products.style.maxHeight = "50vh !important";
    }*/
}

